<div class="bg-th-blue mt-0 container-fluid py-2">
  <div class="d-flex justify-content-between align-content-center">
    <i
      class="fa fa-arrow-left text-secondary my-auto pointer text-white"
      routerLink="/"
    ></i>
    <a class="d-flex align-items-center text-secondary f18 my-auto text-white">
      <span> گزارش عملکرد دیزل‌ها </span>
    </a>
  </div>
</div>

<main class="px-2">

  <div class="container-fluid row gx-2 gy-2 mt-3 p-2">
    <!-- فرم جستجو -->
    <form [formGroup]="searchForm" (ngSubmit)="fetchData()" class="mb-3">
      <div class="row g-3 align-items-end">
        <!-- از تاریخ -->
        <div class="col-12 col-md-4 col-lg-3 position-relative">
          <label class="form-label mb-1">از تاریخ</label>
          <ng-persian-datepicker
            [uiTheme]="'gray'"
            [timeEnable]="false"
            [dateGregorianFormat]="'YYYY/MM/DD'"
            [dateInitValue]="true"
            [dateFormat]="'jYYYY/jMM/jDD'"
          >
            <input
              formControlName="strSDate"
              class="form-control text-end"
              dir="ltr"
            />
          </ng-persian-datepicker>
        </div>

        <!-- تا تاریخ -->
        <div class="col-12 col-md-4 col-lg-3 position-relative">
          <label class="form-label mb-1">تا تاریخ</label>
          <ng-persian-datepicker
            [uiTheme]="'gray'"
            [timeEnable]="false"
            [dateGregorianFormat]="'YYYY/MM/DD'"
            [dateInitValue]="true"
            [dateFormat]="'jYYYY/jMM/jDD'"
          >
            <input
              formControlName="strEDate"
              class="form-control text-end"
              dir="ltr"
            />
          </ng-persian-datepicker>
        </div>

        <!-- دکمه جستجو -->
        <div class="col-12 col-md-4 col-lg-2">
          <button class="btn btn-primary w-100" type="submit">جستجو</button>
        </div>
      </div>
    </form>

    <!-- جستجو -->
    <div class="col-12 col-md-10">
      <input
        class="w-100 form-control"
        (input)="filterList($event.target)"
        placeholder="جستجو کنید ..."
      />
    </div>

    <!-- خروجی اکسل -->
    <div class="col-12 col-md-auto d-flex align-items-center">
      <button class="btn btn-success w-100" type="button">خروجی اکسل</button>
    </div>

    <!-- جدول اطلاعات -->
    <div class="section border mt-4">
      <table class="col-12 table table-striped rounded-3" id="Export_Excel">
        <thead>
          <tr class="text-center">
            <th scope="col">#</th>
            <th scope="col">تاریخ شروع</th>
            <th scope="col">تاریخ پایان</th>
            <th scope="col">روز</th>
            <th scope="col">نام</th>
            <th scope="col">برند</th>
            <th scope="col">مدل</th>
            <th scope="col">مدت فعالیت </th>
            <th scope="col">مدت تحت بار </th>
            <th scope="col">مدت تحت بی باری </th>
            <th scope="col">مدت تحت اضافه بار </th>
            <th scope="col">تعداد استارت</th>
            <th scope="col">مصرف سوخت</th>
            <th scope="col">انرژی تولیدی</th>
            <th scope="col">راندمان</th>
          </tr>
        </thead>

        <tbody>
          <tr class="f14 text-center" *ngFor="let item of reportPerformance; let i = index">
            <th scope="row" class="text-dark">{{ i + 1 | faNum }}</th>
            <td>{{ item.strSDate | faNum }}</td>
            <td>{{ item.strEDate | faNum }}</td>
            <td>{{ item.iDays | faNum }}</td>
            <td>{{ item.strName | faNum }}</td>
            <td>{{ item.strBrand | faNum }}</td>
            <td>{{ item.strModel | faNum }}</td>
            <td>{{ item.strRunTimeSec | faNum }}</td>
            <td>{{ item.strLoadedRunTimeSec | faNum }}</td>
            <td>{{ item.strIdleRunTimeSec | faNum }}</td>
            <td>{{ item.strOverloadDurationSec | faNum }}</td>
            <td>{{ item.iRunCount | faNum }}</td>
            <td>{{ item.fFuelConsumed | faNum }}</td>
            <td>{{ item.fEnergyProduced  | faNum }}</td>
            <td>{{ item.tiEfficiencyScore  | faNum }}</td>
          </tr>
        </tbody>
        <tfoot>
        <tr class="col-12 text-center">
            <th colspan="7">جمع کل</th>
            <td>{{ strTotalRunTimeSec | faNum }}</td>
            <td>{{ strTotalLoadedRunTimeSec | faNum }}</td>
            <td>{{ strTotalIdleRunTimeSec | faNum }}</td>
            <td>{{ strTotalOverloadDurationSec | faNum }}</td>
            <td>{{ totalRunCount | faNum }}</td>
            <td>{{ totalFuelConsumed | faNum }}</td>
            <td>{{ totalEnergyProduced | faNum }}</td>
            <td></td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</main>
